package com.eladfinish.bible.contest.utils

import io.github.aakira.napier.Napier
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.jsonObject
import kotlin.math.abs

object SheetUtil {

    const val JSON = "json"
    const val PREFIX = "gsx$"
    const val CONTENT = "\$t"

    fun getSpreadsheetId(url: String): String {
        if (url.matches("[a-zA-Z\\d_-]+".toRegex())) {
            return url
        }
        val str = "/d/"
        val beginIndex = url.indexOf(str) + str.length
        var endIndex = url.lastIndexOf("/")
        if (abs(endIndex - beginIndex) <= 1) {
            endIndex = url.length
        }
        return url.substring(beginIndex, endIndex)
    }

    //retrieve the fields of the spreadsheet.
    //For that purpose, just check only the first record.
    fun getFieldListFromSheet(entryArray: JsonArray?): ArrayList<String> {
        val fields = ArrayList<String>()
        Napier.e("fields of the spreadsheet: ")
        //in case of an empty table return an empty field list
        if (entryArray == null) {
            return fields
        }

        val keys = entryArray[0].jsonObject.keys
        keys.forEach { key ->
            Napier.e("key: $key")
            if (key.startsWith(PREFIX)) {
                val field = key.substring(PREFIX.length)
                fields.add(field)
            }
        }
        Napier.e("fields prefixed by gsx$: $fields")
        return fields
    }

    //retrieve the fields of the spreadsheet.
    //For that purpose, just check only the first record.
    fun getFieldListFromSheet(jsonElements: List<JsonElement>?): ArrayList<String> {
        val fields = ArrayList<String>()
        Napier.e("fields of the spreadsheet: ")
        //in case of an empty table return an empty field list
        if (jsonElements == null) {
            return fields
        }
        val keySet = jsonElements[0].jsonObject.keys
        for (key in keySet) {
            Napier.e("key: $key")
            if (key.startsWith(PREFIX)) {
                val field = key.substring(PREFIX.length)
                fields.add(field)
            }
        }
        Napier.e("fields prefixed by 'gsx$': $fields")
        return fields
    }
}

@Serializable
data class Sheet(
    @SerialName("version") val version: String,
    @SerialName("feed") val feed: Feed,
)

@Serializable
data class Feed(
    @SerialName("title") val title: String,
    @SerialName("updated") val updated: String,
    @SerialName("author") val authors: List<Author>,
    @SerialName("entry") val rows: List<JsonElement>,
)

@Serializable
data class Author(
    @SerialName("name") val name: String,
    @SerialName("email") val email: String,
)
